"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENTITY_DEPENDENCE_HELPER_MARKERS = exports.MAX_CHILDREN_PER_PARENT = exports.MAX_ENTITIES_PER_SESSION = exports.MISSING_ENTITY_FALLBACK_SCENE_ID = exports.MISSING_ENTITY_SCENE_ID = exports.ENTITY_DISPLAY_NAME_VAR = void 0;
/** Convention variable read by {@link getEntityDisplayName}. */
exports.ENTITY_DISPLAY_NAME_VAR = 'display_name';
/** Required recovery scene id (default injected like character_menu). */
exports.MISSING_ENTITY_SCENE_ID = 'missing_entity';
/**
 * Safe Back/Continue target from the default {@link MISSING_ENTITY_SCENE_ID} scene.
 * Prefer a fixed non-dependent hub over `${return_scene}` to avoid bounce loops
 * into other entity-dependent scenes.
 */
exports.MISSING_ENTITY_FALLBACK_SCENE_ID = 'adventure_menu';
/** Hard cap on entity instances in a session (v1 session-scoped graph). */
exports.MAX_ENTITIES_PER_SESSION = 200;
/** Hard cap on direct children under a single parent entity. */
exports.MAX_CHILDREN_PER_PARENT = 50;
/** Script / content markers that mark a scene as entity-dependent for present/refresh. */
exports.ENTITY_DEPENDENCE_HELPER_MARKERS = [
    // Read / present-time context (invalid current entity → missing_entity)
    'currentEntity(',
    'getEntityDisplayName(',
    'getEntityParent(',
    'getEntityType(',
    'getEntityVariable(',
    'parent=current',
    // Destroy / clear on the current instance while presenting a visit scene
    'destroyEntity(',
    'clearCurrentEntity('
    // Intentionally omitted (authoring/create flows): createEntity(, setCurrentEntity(,
    // setEntityVariable(, entityExists( — those appear on create-form option Effects and must
    // not force missing_entity when entering a blank create scene.
];
//# sourceMappingURL=constants.js.map